import React from 'react';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import ProductsPage from './pages/ProductsPage';
import OrdersPage from './pages/OrdersPage';
import CategoriesPage from './pages/CategoriesPage';
import ProductEditPage from './pages/ProductEditPage';
import SlidesPage from './pages/SlidesPage';
import OrderStatusPage from './pages/OrderStatusPage';
import AdminLayout from './components/AdminLayout';
import ProductAddPage from './pages/ProductAddPage';
import OrderDetailPage from './pages/OrderDetailPage';
import AdminSectionManager from './pages/OfferEditing';

import BillPage from './pages/BillPage'; 



function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/" element={<AdminLayout />}>
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="products" element={<ProductsPage />} />
          <Route path="products/add" element={<ProductAddPage />} />
          <Route path="products/edit/:id" element={<ProductEditPage />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="categories" element={<CategoriesPage />} />
          <Route path="slides" element={<SlidesPage />} />
        
<Route path="/orders/:orderId" element={<OrderDetailPage />} />
<Route path="/orders/:orderId/status" element={<OrderStatusPage />} />
  <Route path="/bill/:orderId" element={<BillPage />} />
<Route path="/admin/sections" element={<AdminSectionManager />} />

        </Route>
      </Routes>
    </Router>
  );
}

export default App;




